import { DetailedViewModal } from 'components/impfschaeden/uebersicht/EntryCard/EntryDetails.js';
import { Col, Input, Row, Stack, StyledEntryCard, Switch } from 'components/ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const BestaetigenForm = ({ update, formData, loading, edit }) => {
	const [t] = useTranslation();
	return (
		<>
			<Row>
				<Col xs={12}>
					{/* <EntryCard {...formData} edit={edit} long={true} preview={true} /> */}
					<StyledEntryCard
						style={{
							boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
							padding: '12px',
							marginBottom: '20px',
						}}
					>
						<DetailedViewModal
							{...formData}
							edit={edit}
							long={true}
							preview={true}
						/>
					</StyledEntryCard>
				</Col>
			</Row>
			{!formData.promi && (
				<Row>
					<Col>
						<Stack gap={3}>
							<Switch
								label={t('impfschaeden.erfassen.zeige_vorname')}
								checked={formData.visible_first_name}
								disabled={loading}
								onChange={() =>
									update({
										visible_first_name:
											formData.visible_first_name == 1 ? 0 : 1,
									})
								}
							/>

							<Switch
								label={t(
									'impfschaeden.erfassen.ersten_buchstaben_nachname_anzeigen'
								)}
								value={formData.visible_last_name == 1}
								checked={formData.visible_last_name == 1}
								disabled={loading}
								onChange={() =>
									update({
										visible_last_name: formData.visible_last_name == 1 ? 0 : 1,
									})
								}
							/>
							<Switch
								label={t('impfschaeden.erfassen.ort_anzeigen')}
								value={formData.visible_city}
								checked={formData.visible_city == 1}
								disabled={loading}
								onChange={() =>
									update({
										visible_city: formData.visible_city == 1 ? 0 : 1,
									})
								}
							/>
							<Switch
								label={t('impfschaeden.erfassen.foto_anzeigen')}
								value={formData.visible_avatar}
								checked={formData.visible_avatar == 1}
								disabled={loading}
								onChange={() =>
									update({
										visible_avatar: formData.visible_avatar == 1 ? 0 : 1,
									})
								}
							/>
						</Stack>
						<Input
							// honey pot
							className='d-none'
							type='text'
							label={t('nutzerbereich.registrieren.email') + ' *'}
							value={formData?.email}
							onChange={(e) => {
								update({
									email: e.target.value,
								});
							}}
							aria-autocomplete='none'
						/>
					</Col>
				</Row>
			)}
		</>
	);
};

BestaetigenForm.propTypes = {
	update: PropTypes.string,
	formData: PropTypes.object,
	validation: PropTypes.object,
	loading: PropTypes.bool,
	edit: PropTypes.bool,
};

export { BestaetigenForm };
